import { Navigate, Outlet } from 'react-router-dom';

import { selectIsTenantAuthenticated } from '~tenant-modules/auth/store/tenant-auth-selectors';

import { useAppSelector } from '~system/store/configure-store';
import { selectActiveScope } from '~system/store/scope/scope-selectors';

import { ROUTES } from '~app/router/routes';

export const TenantGuestOnlyRoute = () => {
  const isAuthenticated = useAppSelector(selectIsTenantAuthenticated);
  const activeScope = useAppSelector(selectActiveScope);

  return isAuthenticated ? <Navigate to={ROUTES.TENANT_SCOPE} /> : <Outlet />;
};
